import { Button } from "devextreme-react";
import React from "react";

export default function TrainingAttendanceList(props) {
  const { trainerSig, traineeSig } = props;

  return (
    <React.Fragment>
      <a
        href="#"
        className="dx-link dx-icon-check dx-link-icon"
        title="Signature"
        aria-label="Signature"
        style={{
          backgroundColor:
            traineeSig > 0 || trainerSig == null
              ? "rgba(244, 67, 54, 0.32)"
              : "transparent",
        }}
      ></a>
      {/* <Button
        icon={"check"}
        style={{
          marginTop: "0px",
          marginBottom: "0px",
          paddingTop: "0px",
          paddingBottom: "0px",
          backgroundColor: "rgba(244, 67, 54, 0.32)",
          width: "18px",
          height: "18px",
          backgroundPosition: "0 0",
          backgroundSize: "18px 18px",
          padding: 0,
          fontSize: "18px",
          textAlign: "center",
          lineHeight: "18px",
          margin: "0 2px",
          verticalAlign: "middle",
        }}
        // onClick={onClick}
        // disabled={sigEmployeeNo == employeeNo ? false : true}
      /> */}
    </React.Fragment>
  );
}
